import React from 'react'
import StoreListTable from '../../components/Merchant/StoreListTable';

const StoreList = () => {
  return (
    <StoreListTable />
  )
}

export default StoreList;